/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAdminOSG
 */
export interface OutputAdminOSG {
    /**
     * 
     * @type {number}
     * @memberof OutputAdminOSG
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputAdminOSG
     */
    name: string;
}

/**
 * Check if a given object implements the OutputAdminOSG interface.
 */
export function instanceOfOutputAdminOSG(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputAdminOSGFromJSON(json: any): OutputAdminOSG {
    return OutputAdminOSGFromJSONTyped(json, false);
}

export function OutputAdminOSGFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAdminOSG {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function OutputAdminOSGToJSON(value?: OutputAdminOSG | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

